<template>
  <!-- 直播页面 -->
  <div class="live">
    <div class="live_title">
      <div class="logo"></div>
      <span>{{videoInfo.name}}</span>
    </div>
    <div class="live_content">
      <div class="video">
        <div id="id_test_video" ref="tc_video"></div>
      </div>

      <div class="info">
        <div class="info_t">
          <!-- phaseName 学段(年级)   subjectName 学科(语数英)  -->

          <span v-if="videoInfo.phaseName">
            {{ videoInfo.phaseName }}
            <template v-if="videoInfo.subjectName">
              · {{videoInfo.subjectName }}
            </template>
          </span>

          <h3>{{videoInfo.name}}</h3>
          <div class="company">
            <el-tooltip class="item" effect="dark" popper-class='description_tip' :content="videoInfo.organizer"
              placement="top" :disabled='organizerTip'>
              <div>
                主办单位：
                {{videoInfo.organizer ? valFilter(videoInfo.organizer, 50) : ''}}
              </div>
            </el-tooltip>
          </div>

          <div class="company">
            <el-tooltip class="item" effect="dark" popper-class='description_tip' :content="videoInfo.description"
              placement="top-start" :disabled='isDisabled'>
              <div>活动简介：{{videoInfo.description ? valFilter(videoInfo.description, 200) : ''}}</div>
            </el-tooltip>

          </div>
          <span class="reason">活动简介</span>
        </div>
        <div class="info_b">
          <el-card class="card" v-for="(item, index) in activityInfo" :key="index">
            <div class="card_title">
              <img :src="item.icon" alt="">
              <h4>{{item.title}}</h4>
            </div>
            <el-tooltip class="item" effect="dark" popper-class='description_tip' :content="videoInfo.organizer"
              placement="top" :disabled='organizerTip'>
              <div>{{videoInfo.organizer ? valFilter(videoInfo.organizer, 50) : ''}}</div>
            </el-tooltip>

          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const moment = require('moment');
export default {
  components: {},
  props: {},
  data() {
    return {
      isDisabled: true,
      organizerTip: true,
      player: null,
      liveId: "", // 视频id
      videoInfo: {}, // 视频信息
      activityInfo: [
        {
          title: "主办机构",
          icon: require("../../assets/img/live/org.png"),
        },
      ],
    };
  },
  methods: {
    valFilter(str, maxLen) {
      if (str) {
        if (str.length > maxLen) {
          return str.slice(0, maxLen) + "...";
        }
        return str;
      } else {
        return "";
      }
    },
    // 获取录播地址
    async getVideoInfo(liveId) {
      try {
        let req = {
          liveId,
        };
        let { code, data } = await this.$api.live.getLive(req);
        if (code === "1") {
          if (data.description) {
            this.isDisabled = data.description.length > 200 ? false : true;
          }
          if (data.organizer) {
            this.organizerTip = data.organizer.length > 50 ? false : true;
          }
          this.videoInfo = data;
          this.initPlayer(data.recordingUrl);
        } else {
          this.$message.error("异常错误");
        }
      } catch (error) {
        console.log(error);
        // this.$message.error("异常错误");
      }
    },
    initPlayer(url) {
      let currentTime = moment().diff(moment(this.videoInfo.startDate), 'seconds')
      console.log(currentTime,this.videoInfo);
      this.player = new TcPlayer("id_test_video", {
        m3u8: url, //请替换成实际可用的播放地址
        autoplay: true,
        live: true,
        width: "90%", // 480 视频的显示宽度，请尽量使用视频分辨率宽度
        height: "100%", // 320 视频的显示高度，请尽量使用视频分辨率高度
      });
      

      this.player.currentTime(currentTime); // 自定义播放时间点 单位s
    },
  },
  mounted() {
    this.liveId = this.$route.query.liveId;
    this.getVideoInfo(this.liveId);
  },
};
</script>
<style lang="less">
.description_tip {
  max-width: 300px;
  line-height: 1.7;
}
.video {
  .vcp-player {
    display: flex !important;
    justify-content: center !important;
    width: 100% !important;
  }
}
</style>
<style lang="less" scoped>
.live {
  background: #f7f7f7;
  min-width: 1200px;
  min-height: calc(100%);
  .live_title {
    color: #727272;
    display: flex;
    align-items: center;
    padding: 5px 10px;
    .logo {
      background-image: url("../../assets/img/live/video_logo.png");
      width: 67px;
      height: 40px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  .live_content {
    height: calc(100% - 50px);
    display: flex;
    .video,
    .info {
      height: 100%;
    }
    .video {
      width: 85%;
      #id_test_video {
        height: calc(100vh - 50px);
      }
    }
    .info {
      min-width: 350px;
      max-width: 350px;
      .info_t {
        min-height: 330px;
        background-image: url("../../assets/img/live/live_ri_bgc.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding: 20px;
        position: relative;
        padding-bottom: 52px;
        span:first-child {
          background: #f22735;
          color: #fff;
          line-height: 28px;
          padding: 2px 5px;
          display: inline-block;
        }
        h3 {
          margin: 10px 0;
          color: #45435e;
          letter-spacing: 5px;
        }

        .company {
          font-size: 14px;
          color: #606077;
          width: 80%;
          line-height: 1.5;
        }
        .reason {
          background: #f22735;
          color: #fff;
          line-height: 28px;
          padding-left: 20px;
          padding: 2px 5px;
          position: absolute;
          bottom: 0px;
        }
      }
      .info_b {
        padding: 20px;
        .card {
          margin-bottom: 20px;
          .card_title {
            display: flex;
            img {
              width: 18px;
              height: 20px;
            }
            h4 {
              margin-left: 5px;
            }
          }
          div:last-child {
            font-size: 14px;
            color: #6d6d73;
            margin-left: 20px;
            margin-top: 10px;
            line-height: 1.5;
          }
        }
        /deep/ .el-card__body {
          padding: 10px;
        }
      }
    }
  }
}
</style>
